import { defineStore } from "pinia"
import { ref } from "vue"

const STORAGE_KEY = 'AUTH_TOKEN_STORAGE'
const STORE_KEY = 'AUTH_TOKEN_STORE'

const getFromLocalStorage = (): string => {
    return localStorage.getItem(STORAGE_KEY) || ''
}
export const useAuthTokenStore = defineStore(STORE_KEY, () => {
    const authToken = ref<string>(getFromLocalStorage())

    function saveAuthToken(token: string) {
        authToken.value = token
        updateLocalStorage()
    }
    function updateLocalStorage() {
        localStorage.setItem(STORAGE_KEY, authToken.value)
    }

    return { saveAuthToken, authToken }
})